import { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { notification } from "antd";
import { Field } from "formik";

import { Button, Fields } from "components";
import { useGet, useHooks } from "hooks";
import Container from "modules/container";

const BannerUpdate = () => {
  const navigate = useNavigate();
  const { get, t } = useHooks();

  const { data: bannerData } = useGet({
    name: "banner",
    url: `/banner`,
  });

  const data = get(bannerData, "data[0]");

  // "image" | "video"
  const initialType: "image" | "video" = useMemo(
    () => (get(data, "type") === "video" ? "video" : "image"),
    [data]
  );

  const [innerPage, setInnerPage] = useState<"image" | "video">(initialType);

  return (
    <div>
      <Container.Form
        url={"/banner/"}            // sizning API’ingizga mos holda qolsin
        name="banner"
        method="put"
        fields={[
          {
            type: "string",
            name: "type",
            value: initialType,
            // string/option-obj ikkalasini ham to'g'ri jo'natish
            onSubmitValue: (val: any) => {
              if (typeof val === "string") return val;              // "image" | "video"
              if (val && typeof val === "object" && "value" in val) return val.value;
              return innerPage;                                     // fallback
            },
          },
          {
            type: "any",
            name: "video",
            value: get(data, "video"),
          },
          {
            type: "any",
            name: "images",
            value: get(data, "images"),
          },
        ]}
        onSuccess={(res, resetForm) => {
          notification.success({ message: t("Muvaffaqiyatli"), duration: 2 });
          resetForm();
          navigate("/banner");
        }}
        onError={(error) => {
          notification.error({
            message: get(error, "errorMessage", t("Something went wrong!")),
            duration: 2,
          });
        }}
      >
        {({ setFieldValue, submitForm, values }) => {
          return (
            <div className="form-wrapper">
              <div className="form__left-side">
                <div className="">
                  {/* Images */}
                  <div className="flex justify-between mb-[30px]">
                    <div className="content-panel w-full">
                      <p className="content-panel-title mb-[20px]">
                        {t("Banner rasmi")}
                      </p>
                      <Field
                        name="images"
                        component={Fields.FileUpload}
                        placeholder={t("Rasm joylash")}
                        className="mb-[10px] object-fill"
                        multiple
                        maxFiles="3"
                      />
                    </div>
                  </div>

                  {/* Video */}
                  <div className="flex justify-between mb-[30px]">
                    <div className="content-panel w-full">
                      <p className="content-panel-title mb-[20px]">
                        {t("Banner videosi")}
                      </p>
                      <Field
                        name="video"
                        component={Fields.FileUpload}
                        placeholder={t("Video joylash")}
                        className="mb-[10px] object-fill"
                        accept=".mp4,.mov,.gif"
                        isVideo
                      />
                    </div>
                  </div>

                  {/* Type selector */}
                  <div className="content-panel">
                    <Fields.SelectD
                      //@ts-ignore
                      placeholder={t("Tanlang")}
                      // SelectD optionlari
                      options={[
                        { id: 1, label: "Image", value: "image" },
                        { id: 2, label: "Video", value: "video" },
                      ]}
                      optionLabel="label"
                      optionValue="value"
                      isSearchable={false}
                      // ko'rsatilayotgan qiymat (values.type string bo'lsa ham ishlaydi)
                      defaultValue={{
                        label: (values?.type ?? innerPage) === "video" ? "Video" : "Image",
                        value: (values?.type ?? innerPage) as "image" | "video",
                      }}
                      onChange={(opt: any) => {
                        const v = opt?.value === "video" ? "video" : "image";
                        setInnerPage(v);
                        setFieldValue("type", v); // FORMIK ga yozamiz
                      }}
                      className="w-[140px]"
                    />
                  </div>

                  {/* Actions action */}
                  <div className="content-panel">
                    <Button
                      type="default"
                      title={t("Bekor qilish")}
                      className="w-full mt-[20px] bg-[#fff]"
                      onClick={() => navigate("/banner")}
                    />
                    <Button
                      type="primary"
                      className="w-full mt-[20px]"
                      onClick={submitForm}
                      title={get(bannerData, "data") ? t("Saqlash") : t("Tasdiqlash")}
                    />
                  </div>
                </div>
              </div>
            </div>
          );
        }}
      </Container.Form>
    </div>
  );
};

export default BannerUpdate;
